export const ACL_REQUEST = 'ACL_REQUEST'
export const ACL_SUCCESS = 'ACL_SUCCESS'
export const ACL_ERROR = 'ACL_ERROR'
export const ACL_RESET = 'ACL_RESET'
